import { isNil } from 'lodash';
import { roundOff } from './math/valueRounder';

export const labelNullFormatter = (value) => (isNil(value) ? 'N/A' : value);

export const valueNullFormatter = (value) =>
  isNil(value) ? 0 : roundOff(value, 1);
